import { useEffect, useState } from 'react';
import MenuItem from './MenuItem';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import arrow from 'assets/svg/common/arrow.svg';
import SvgRender from 'common/components/general/SvgRender';

const Menu = () => {
  const menu = useSelector(state => state.sidebar.menu);
  const [active, setActive] = useState(null);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const { location } = useRouter();

  useEffect(() => {
    const item = menu.items.find(item => location.pathname.includes(item.label));

    setActive(item);
    setIsSubmenuOpen(item?.submenu && !item?.hiddenSubmenu);
  }, []);

  return (
    <div
      className={`sidebar-menu d-flex flex-column h-100p py-5 ${
        isSubmenuOpen && active && active.submenu && !active.hiddenSubmenu ? ' submenu-open' : ''
      }`}
    >
      <div className="ps-2 text-uppercase">
        {isSubmenuOpen && active && active.submenu && !active.hiddenSubmenu
          ? active.name
          : 'OCEAN.TOOLS'}
      </div>
      <div className="sidebar-menu--inner flex-1 mt-5">
        <div className="sidebar-menu--section sidebar-menu--top">
          {menu.items
            .filter(item => item.visibility !== 'hidden')
            .map((item, index) => (
              <MenuItem
                setIsSubmenuOpen={setIsSubmenuOpen}
                active={active}
                setActive={setActive}
                key={index}
                item={item}
              />
            ))}
        </div>

        <div className="sidebar-menu--section sidebar-menu--sub">
          {isSubmenuOpen && active && active.submenu && !active.hiddenSubmenu && (
            <div className="sidebar-menu--sub-inner">
              <div
                className="sidebar-menu--sub-back mb-2 d-inline-flex align-items-center"
                onClick={() => setIsSubmenuOpen(false)}
              >
                <SvgRender src={arrow} style={{ width: 10, height: 10 }} />
                <span>Back to menu</span>
              </div>
              {active.submenu.map((item, index) => (
                <MenuItem
                  setIsSubmenuOpen={setIsSubmenuOpen}
                  active={active}
                  setActive={setActive}
                  key={index}
                  item={item}
                  sub
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Menu;
